module.controller('requestFundsCtrl', ['$scope', '$rootScope', '$http', '$state', '$filter', 'cacheService', 'Transform', 'Session', 'memberService', 'baseURI', 'OVERLAY',
  function ($scope, $rootScope, $http, $state, $filter, cacheService, Transform, Session, memberService, baseURI, OVERLAY){
    var requestUrl = baseURI + 'request';
    var searchUrl = baseURI + 'cardholder/search/';

    $scope.memberTypes = {
      'sub': 'Cards',
      'favorites': 'Favorites',
      'phone': 'Phone Contacts'
    };

    $scope.overlay = OVERLAY['member.home.request'];
    $scope.formData = {};
    $scope.transferTo = {};
    $scope.searchInput = {};
    $scope.searchInput.memberSearched = '';
    $scope.memberResult = [];
    $scope.memberType = 'Cards';
    $scope.attempted = false;
    $scope.searchLoading = false;
    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to process the request at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
    $scope.balance = $rootScope.balance;

    $scope.clearMessage = function(){
      $scope.formData.Note = '';
    };

    // Search in step1
    $scope.search = function(value){
      if(value.length > 2 || value === ''){
        $scope.searchLoading = true;
        $http.get(searchUrl + encodeURI(value))
          .then(function (resp){
            var data = resp.data;
            if(value == $scope.searchInput.memberSearched){
              if(data.Data){
                $scope.memberType = memberService.getType(data.Data[0].Type);
                $scope.memberResult = data.Data;
              } else {
                $scope.memberResult = [];
              }
            }
          }).catch(function (error){
            console.log('error', error);
          }).then(function (){
            $scope.searchLoading = false;
          });
      }
    };

    // Creates an array of member types (favorites, subs)
    $scope.groupMembers = function(){
      var groupMembers = [];

      angular.forEach($scope.memberResult, function (member, key){
        if(groupMembers.indexOf(member.Type) == -1){
          groupMembers.push(member.Type);
        }
      });

      return groupMembers;
    };

    // CH clicked on memberResult index
    $scope.selectMember = function(member){
      $scope.transferTo = member;
      $state.go('member.home.request.step2');
    };

    // Validation for step2
    $scope.attemptSubmission = function (formData){
      if(formData.$valid){
        $scope.alert.errorShown = false;
        $state.go('member.home.request.step3');
      } else {
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      }
    };

    // Review and submit
    $scope.processForm = function(formData){
      $scope.loading = true;
      var transferTo = $scope.transferTo;
      formData.ToType = transferTo.Type;
      formData.Note = formData.Note || '';

      // Check transfer type
      switch(formData.ToType){
        case 'favorites':
        case 'sub':
        case 'akimbo':
        case 'phone':
          formData.ToType = 'akimbo';
          formData.ToUsername = transferTo.Username;
          break;
        case 'email':
          formData.ToEmail = transferTo.Email;
          break;
        case 'fb':
          formData.ToFbId = transferTo.FbId;
          break;
      }

      $http({
        method: 'POST',
        url: requestUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode(formData)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        if(data.Success){
          // Clear the balance and feed cache
          cacheService.clear('transfer');

          $state.go('member.home.request.step4');
          $scope.alert.successShown = true;
          $scope.alert.successMessage = 'You\'ve requested ' + $filter('akimboCurrency')(formData.Amount, '$') + ' from ' + (transferTo.Username || transferTo.Email || transferTo.FirstName);
        } else {
          $scope.alert.alertShown = true;
        }
      }).catch(function (error){
        $scope.loading = false;
        $scope.alert.alertShown = true;
      });
    };

    // Prepopulate list with subscards
    $scope.search('');
}]);
